import React, { FC, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useAlert } from 'react-alert'
import {
  updateUrlStatus,
} from '../../../states/containers/setting/systemSlice'
import { useTranslation } from 'react-i18next'
import { RootState } from '../../../states/containers/store'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconName } from '@fortawesome/fontawesome-common-types'
import LoadingSquare from '../common/LoadingSquare'

const UrlDetailStatus: FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const alert = useAlert()

  const {
    system,
  } = useSelector((state: RootState) => (state))

  const [hideUrlDetail, setHideUrlDetail] = useState<boolean>(!!system.hide_url_detail)
  const [isChange, setIsChange] = useState<boolean>(false)

  const CanSubmit = () => {
    if (hideUrlDetail === !!system.hide_url_detail) {
      setIsChange(false)
    } else {
      setIsChange(true)
    }
  }

  useEffect(() => {
    if (system.hide_url_detail === undefined) return
    setHideUrlDetail(!!system.hide_url_detail)
    CanSubmit()
  }, [system.hide_url_detail])

  useEffect(() => {
    CanSubmit()
  }, [hideUrlDetail])

  const handleUrlSubmit = () => {
    if (!isChange) return
    dispatch(
      updateUrlStatus(
        { hide_url_detail: hideUrlDetail },
        () => {
          alert.success(t('form.alert.updated'))
        },
      ),
    )
  }

  return (
    <>
      {
        system.isLoading ? (
          <LoadingSquare>
            <>
              設定を読み込んでいます…
            </>
          </LoadingSquare>
        ) : (
          <>
            <div
              className={`graphical_check_box${hideUrlDetail ? " selected" : ""}`}
              onClick={() => setHideUrlDetail(!hideUrlDetail)}
              role="none"
            >
              <FontAwesomeIcon
                icon={['far', `${hideUrlDetail ? 'check-square' : 'square'}` as IconName]}
                className={`icon ${hideUrlDetail ? "checked" : "no_check"}`}
              />
              <div>
                <div className="check_box_title">
                  {t('setting.common.url_detail.label')}
                </div>
                <div className="check_box_description">
                  URLとページタイトルを非表示にすることができます
                </div>
              </div>
            </div>
            <button
              type="button"
              className="mt-4 button"
              onClick={handleUrlSubmit}
              disabled={!isChange}
            >
              {t('setting.common.url_detail.button_text')}
            </button>
          </>
        )
      }
    </>
  )
}

export default UrlDetailStatus
